import React, { createContext, useContext, useState, useCallback } from "react";

const AuthModalContext = createContext(null);
export const PENDING_KEY = "ishukart_pending_prompt";

export const AuthModalProvider = ({ children }) => {
  const [mode, setMode] = useState(null); // 'login' | 'signup' | 'forgot' | null
  const openLogin = useCallback(() => setMode("login"), []);
  const openSignup = useCallback(() => setMode("signup"), []);
  const openForgot = useCallback(() => setMode("forgot"), []);
  const close = useCallback(() => setMode(null), []);
  const switchMode = useCallback((m) => setMode(m), []);
  return (
    <AuthModalContext.Provider value={{ mode, openLogin, openSignup, openForgot, close, switchMode }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext);
  if (!ctx) throw new Error("useAuthModal must be used within AuthModalProvider");
  return ctx;
};
